// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { UserRole } from '../../helios/types';

/** The four roles the UI knows (IAM: OrgAdmin, Operations-Manager, Operator, Executive). */
export type CanonicalRole = UserRole;

/**
 * The one display name for each role. Admin Center's role dropdown and Home
 * role breakdown, the profile menu and the persona labels all read this, so a
 * role never shows under two names. IAM's own names map to these in `helios/services/authService.ts`.
 */
export const ROLE_LABELS: Record<CanonicalRole, string> = {
  admin: 'Admin',
  operations_manager: 'Owner',
  operator: 'Member',
  executive: 'Viewer',
};
